import { useQuery } from '@apollo/react-hooks';

import { SYLLABUS_MODE } from 'Domains/syllabus';
import { getSectionReport, getTKSectionReport } from 'GraphQL/queries/report.query';

const SectionReportData = ({ value, schoolCode, children }) => {
  const { term, grade, classNo, subject, syllabus, lesson, quizFilter, mode } = value;

  const variables = {
    schoolTermId: term,
    schoolGradeId: grade !== `all-grade-selected` ? grade : null,
    classNo: classNo !== `all-class-selected` ? classNo : null,
    subjectId: subject,
    courseCode: syllabus,
    sectionCode: lesson !== `all-lesson-selected` ? lesson : null,
    schoolCode,
    quizFilter,
  };

  const isSkip = !term || !grade || !classNo || !subject || !syllabus || !lesson || !schoolCode;

  const traditionalReport = useQuery(getSectionReport, {
    variables: variables,
    skip: isSkip || mode === SYLLABUS_MODE.TUNGKAI,
    notifyOnNetworkStatusChange: true,
  });

  const tungkaiReport = useQuery(getTKSectionReport, {
    variables: variables,
    skip: isSkip || mode === SYLLABUS_MODE.TRADITIONAL,
    notifyOnNetworkStatusChange: true,
  });

  const report = mode === SYLLABUS_MODE.TRADITIONAL ? traditionalReport : tungkaiReport;

  const { loading, error, data, refetch, networkStatus } = report;

  return children({ loading, error, data, refetch, networkStatus });
};

export default SectionReportData;
